import { type ButtonHTMLAttributes, forwardRef } from "react";
import { classNames } from "../../classNames";
import { Icon, type IconName } from "../../icons";
import { useTooltip } from "../Tooltip/Tooltip";

export interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "type" | "children"> {
  /** Accessible name, also shown as tooltip. */
  label: string;
  icon: IconName;
  size?: "sm" | "md";
  tone?: "default" | "danger";
  tooltip?: boolean;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { label, icon, size = "md", tone = "default", tooltip = true, className, ...rest },
  ref,
) {
  const { anchorProps, tooltip: tip } = useTooltip(label, { disabled: !tooltip });
  const classes = classNames("nb-icon-btn", size === "sm" ? "nb-icon-btn-sm" : null, tone === "danger" ? "nb-icon-btn-danger" : null, className);
  return (
    <>
      <button ref={ref} type="button" aria-label={label} className={classes} {...anchorProps} {...rest}>
        <Icon name={icon} />
      </button>
      {tip}
    </>
  );
});
